import { HashRouter as Router, Routes, Route } from "react-router-dom"; // تغيير BrowserRouter لـ HashRouter
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Projects from "./components/Projects";
import About from "./components/About";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop"; 
import './i18n'; 

function App() {
  return (
    // استخدام Router كإسم مستعار لـ HashRouter
    <Router>
      {/* الناف بار ثابت في كل الصفحات */}
      <Navbar /> 

      {/* المحتوى الرئيسي */}
      <main style={{ minHeight: "100vh", paddingTop: "0px" }}>
        <Routes>
          {/* الصفحة الرئيسية: تجمع كل السكاشن */}
          <Route path="/" element={
            <>
              <Hero />
              <Projects />
              <About />
              <Contact />
            </>
          } />

          {/* صفحات مستقلة */}
          <Route path="/about" element={<About />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </main>

      <Footer /> 
      <ScrollToTop />
    </Router>
  );
}

export default App;